"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var route_service_1 = require("../core/route.service");
var i18n_service_1 = require("../core/i18n.service");
var data_component_1 = require("./data.component");
var routes = route_service_1.Route.withShell([
    { path: 'data', component: data_component_1.DataComponent, data: { title: i18n_service_1.extract('Data') } },
    { path: 'data/:patientNumber', component: data_component_1.DataComponent, data: { title: i18n_service_1.extract('Data') } }
]);
var DataRoutingModule = /** @class */ (function () {
    function DataRoutingModule() {
    }
    DataRoutingModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forChild(routes)],
            exports: [router_1.RouterModule],
            providers: []
        })
    ], DataRoutingModule);
    return DataRoutingModule;
}());
exports.DataRoutingModule = DataRoutingModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1yb3V0aW5nLm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRhdGEtcm91dGluZy5tb2R1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQXlDO0FBQ3pDLDBDQUF1RDtBQUV2RCx1REFBOEM7QUFDOUMscURBQStDO0FBQy9DLG1EQUFpRDtBQUVqRCxJQUFNLE1BQU0sR0FBVyxxQkFBSyxDQUFDLFNBQVMsQ0FBQztJQUNuQyxFQUFDLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLDhCQUFhLEVBQUUsSUFBSSxFQUFFLEVBQUMsS0FBSyxFQUFFLHNCQUFPLENBQUMsTUFBTSxDQUFDLEVBQUMsRUFBQztJQUN4RSxFQUFDLElBQUksRUFBRSxxQkFBcUIsRUFBRSxTQUFTLEVBQUUsOEJBQWEsRUFBRSxJQUFJLEVBQUUsRUFBQyxLQUFLLEVBQUUsc0JBQU8sQ0FBQyxNQUFNLENBQUMsRUFBQyxFQUFDO0NBQzFGLENBQUMsQ0FBQztBQU9IO0lBQUE7SUFDQSxDQUFDO0lBRFksaUJBQWlCO1FBTDdCLGVBQVEsQ0FBQztZQUNOLE9BQU8sRUFBRSxDQUFDLHFCQUFZLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQ3hDLE9BQU8sRUFBRSxDQUFDLHFCQUFZLENBQUM7WUFDdkIsU0FBUyxFQUFFLEVBQUU7U0FDaEIsQ0FBQztPQUNXLGlCQUFpQixDQUM3QjtJQUFELHdCQUFDO0NBQUEsQUFERCxJQUNDO0FBRFksOENBQWlCIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/data/data-routing.module.ts
// module id = 620
// module chunks = 0